import { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '~/components/ui/card';

interface StatusCardProps {
  icon: ReactNode;
  title: string;
  titleClassName?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function StatusCard({
  icon,
  title,
  titleClassName = '',
  children,
  footer,
  className = ''
}: StatusCardProps) {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4 ${className}`}>
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className={`flex items-center gap-2 ${titleClassName}`}>
            {icon}
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {children}
        </CardContent>
        {footer && (
          <CardFooter>
            {footer}
          </CardFooter>
        )}
      </Card>
    </div>
  );
}

export default StatusCard;
